"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var rest_1 = __importDefault(require("../../rest"));
var contentData_1 = require("../mock/contentData");
var contentDataUrl = "".concat(process.env.CB_EMAIL_TEMPLATE_SERVICE_URL, "/content-data");
var ContentData = {
    getAssessments: function (contentDataParams) {
        return rest_1.default.get({
            mockFunc: contentData_1.getAssessments,
            url: "".concat(contentDataUrl, "/assessments"),
            token: contentDataParams.token,
        });
    },
    getChallenges: function (contentDataParams) {
        return rest_1.default.get({
            mockFunc: contentData_1.getChallenges,
            url: "".concat(contentDataUrl, "/challenges"),
            token: contentDataParams.token,
        });
    },
    getTournaments: function (contentDataParams) {
        return rest_1.default.get({
            mockFunc: contentData_1.getTournaments,
            url: "".concat(contentDataUrl, "/tournaments"),
            token: contentDataParams.token,
        });
    },
    getLessons: function (contentDataParams) {
        return rest_1.default.get({
            mockFunc: contentData_1.getLessons,
            url: "".concat(contentDataUrl, "/lessons?first=").concat(contentDataParams.first, "&offset=").concat(contentDataParams.offset),
            token: contentDataParams.token,
        });
    },
    getCourses: function (contentDataParams) {
        return rest_1.default.get({
            mockFunc: contentData_1.getCourses,
            url: "".concat(contentDataUrl, "/courses"),
            token: contentDataParams.token,
        });
    },
    getLeaderboards: function (contentDataParams) {
        return rest_1.default.get({
            mockFunc: contentData_1.getLeaderboards,
            url: "".concat(contentDataUrl, "/leaderboards"),
            token: contentDataParams.token,
        });
    },
};
exports.default = ContentData;
